module.exports = __webpack_public_path__ + "static/media/activate.e212dbb6.gif";